<template>
	<v-app>
		<v-container fluid fill-height id="login-page">
			<v-layout align-center justify-center>
				<v-snackbar v-model="dc4.showChangePassSucess" :timeout="3000" color="success" top>
					Senha alterada com sucesso!
					<template v-slot:action="{ attrs }">
						<v-btn icon color="white" text v-bind="attrs" @click="dc4.showChangePassSucess = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</template>
				</v-snackbar>
				<v-flex :style="{ 'max-width': '400px' }">
					<v-card elevation="2" class="pa-4">
						<div class="d-flex grow flex-wrap justify-center">
							<v-card elevation="8" class="pa-9 mb-n6 v-card--material__heading primary">
								<div class="display-2 text-center white--text"> ORYX PDV </div>
							</v-card>
						</div>
						<v-card-text>
							<div class="text-center mb-4">
								<img src="../../../public/img/magna-data-logo.png" width="100" height="80" />
							</div>

							<transition name="fade" mode="out-in">
								<router-view></router-view>
							</transition>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
			<div class="version-label">Versão: {{ appVersion }}</div>
		</v-container>
	</v-app>
</template>

<script>
	import { version } from '../../../package'

	export default {
		data() {
			return {
				appVersion: version,
			}
		},
		computed: {
			dc4() {
				return this.$store.state.dc4
			}
		},
	}
</script>

<style scoped>
	#login-page {
		background-image: linear-gradient(to top, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
			url(https://magnadata.com.br/assets/uploads/images/banners/banners-2-baixa-jpg-1621907561.jpg);
		background-position: center;
		background-size: cover;
	}

	.v-card--material__heading {
		position: relative;
		top: -30px;
		-webkit-transition: 0.3s ease;
		transition: 0.3s ease;
		z-index: 1;
		min-width: 322px;
	}

	.version-label {
		position: absolute;
		bottom: 10px;
		right: 20px;
		color: white;
		font-size: 0.9rem;
		z-index: 2;
	}
</style>
